import { render, staticRenderFns } from "./TicketsBoard.vue?vue&type=template&id=ee143538&scoped=true&"
import script from "./TicketsBoard.vue?vue&type=script&lang=js&"
export * from "./TicketsBoard.vue?vue&type=script&lang=js&"
import style0 from "./TicketsBoard.vue?vue&type=style&index=0&id=ee143538&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee143538",
  null
  
)

export default component.exports